import { connect } from "@permaweb/aoconnect"

export const { dryrun: dryrunDexiCU } = connect({
  CU_URL: "https://cu-af.dataos.so",
})

export const { dryrun } = connect({
  CU_URL: "https://cu-af.dataos.so",
})
